import type { Locale } from '../client/portal/types.gen';

export const getCurrency = (locale: Locale) => {
  const currencies = {
    DE: 'EUR',
    NO: 'NOK',
    SE: 'SEK',
  };

  return currencies[locale];
};
